<template lang="pug">
.content(:class="{ 'is-sortable': edit && sortable, 'is-deletable': deletable, 'is-restorable': content.deleted }")
    .title-bar(v-if="edit")
        h4.handle
            template(v-if="sortable")
                span.drag-handle-icon(aria-hidden="true")
                    svg(xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor")
                        circle(cx="5.5" cy="3" r="1.25")
                        circle(cx="10.5" cy="3" r="1.25")
                        circle(cx="5.5" cy="8" r="1.25")
                        circle(cx="10.5" cy="8" r="1.25")
                        circle(cx="5.5" cy="13" r="1.25")
                        circle(cx="10.5" cy="13" r="1.25")
                span {{ $t('Content \#{nr}', { nr: index + 1 }) }}
        .grow
        el-button.restore-content(
            v-if="content.deleted"
            circle type="info" size="mini"
            icon="el-icon-fa-trash-restore fas"
            @click.prevent.stop="restoreContent(content.id)"
        )
        el-button.delete-content(
            v-else-if="deletable"
            circle type="danger" size="mini"
            icon="el-icon-fa-trash-alt far"
            @click.prevent.stop="deleteContent(content.id)"
        )
    .fields
        .field(
            v-for="field in config.fields" :key="field.key"
            v-if="config.fields && config.fields.length && checkConditions(field)"
            :class="[field.key, { edit, deleted: content.deleted }]"
        )
            image-content(
                v-if="field.key == 'images'"
                :key="`${content.id}-${field.key}`"
                :section="section"
                :content="content"
                :config="config"
                :options="options"
                :section-settings="sectionSettings"
                :section-setting-values="sectionSettingValues"
                :edit="edit"
            )
            component(
                v-else
                :is="field.key === 'address' ? 'AddressField' : 'InputField'"
                :key="`${content.id}-${field.key}`"
                :section="section"
                :content="content"
                :options="options"
                :config="field"
                :settings="config.settings"
                :section-settings="sectionSettings"
                :section-setting-values="sectionSettingValues"
                :edit="edit"
            )
</template>

<i18n>
{
    "en": {
        "Content #{nr}": "Content #{nr}",
        "Content \\#{nr}": "Content \\#{nr}"
    },
    "de": {
        "Content #{nr}": "{nr}. Inhalt"
    }
}
</i18n>

<script>

import _ from 'lodash'

import store from '@/store'
import { useSetupStore } from '@/stores'
// import router from '@/router'

import InputField from './InputField'
import AddressField from './AddressField'
import ImageContent from './ImageContent'

export default {
    name: 'InputContent',
    props: {
        section: {
            type: Object,
            required: false
        },
        content: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        sortable: {
            type: Boolean,
            default: false
        },
        edit: {
            type: Boolean,
            required: true
        },

        // all setting values as associative object (key: value)
        sectionSettingValues: {
            type: Object,
            default: () => {
                return {}
            }
        },
        sectionSettings: {
            type: Array,
            required: false
        },
    },
    components: {
        InputField,
        AddressField,
        ImageContent,
    },
    computed: {
        contentSettings() {
            let settings = {}

            // get default values
            if (this.config.settings && this.config.settings.length) {
                this.config.settings.forEach(setting => {
                    if (setting.position && setting.position === 'inline' && setting.options && setting.options.length) {
                        const option = setting.options.find(option => option.default === true)
                        settings[setting.key] = option.key
                    }
                })
            }

            // override with actual values
            if (this.content.settings && this.content.settings.length) {
                this.content.settings.forEach(setting => settings[setting.key] = setting.value)
            }

            return settings
        },
        deletable() {
            const min = _.get(this.config, 'min')
            const contents = this.section.contents.filter(content => ! content.deleted)
            return this.edit && min !== null && min < contents.length
        },
        setupStore() {
            return useSetupStore()
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions
        },
    },
    methods: {
        checkConditions(field) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.sectionSettingValues;
            const enabledExtensions = this.enabledExtensions;
            try {
                const conditions = field.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
        deleteContent(id) {
            // const c = _.findIndex(this.section.contents, el => el.id === id)
            // if (c >= 0) {
            //     const payload = {
            //         i: this.i,
            //         s: this.s,
            //         c
            //     }
            //     store.commit(`${this.module}/form/markContentAsDeleted`, payload)
            // }

            const i = this.section.contents.findIndex(el => el.id === id)
            this.$delete(this.section.contents, i);
        },
        restoreContent(id) {
            // const c = _.findIndex(this.section.contents, el => el.id === id)
            // if (c >= 0) {
            //     const payload = {
            //         i: this.i,
            //         s: this.s,
            //         c
            //     }
            //     store.commit(`${this.module}/form/unmarkContentAsDeleted`, payload)
            // }
        }
    }
}
</script>

<style lang="sass" scoped>
.field.edit
    margin-bottom: 22px
    &.deleted
        opacity: .5
        pointer-events: none
        ::v-deep *
            pointer-events: none

.content.is-sortable
    .title-bar
        h4.handle
            cursor: grab
            display: flex
            align-items: center
            gap: 6px
            &:active
                cursor: grabbing

.drag-handle-icon
    display: inline-flex
    align-items: center
    justify-content: center
    width: 20px
    height: 20px
    color: #c0c4cc
    flex-shrink: 0
    transition: color 0.15s ease

.content.is-sortable .title-bar h4.handle:hover .drag-handle-icon
    color: $--color-primary
</style>
